import { 
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
  createUserWithEmailAndPassword,
  updateProfile as firebaseUpdateProfile,
  updatePassword as firebaseUpdatePassword,
  User
} from 'firebase/auth';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { handleAuthError } from './errors';
import { toast } from 'react-hot-toast';

export const createUser = async (email: string, password: string): Promise<User> => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    
    // Create user document
    await setDoc(doc(db, 'users', userCredential.user.uid), {
      email,
      role: 'user',
      createdAt: serverTimestamp(),
      permissions: ['read']
    });
    
    toast.success('Compte créé avec succès');
    return userCredential.user;
  } catch (error) {
    return handleAuthError(error);
  }
};

export const signIn = async (email: string, password: string): Promise<User> => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    toast.success('Connexion réussie');
    return userCredential.user;
  } catch (error) {
    return handleAuthError(error);
  }
};

export const signOut = async (): Promise<void> => {
  try {
    await firebaseSignOut(auth);
    toast.success('Déconnexion réussie');
  } catch (error) {
    return handleAuthError(error);
  }
};

export const updateUserProfile = async (data: { displayName?: string }): Promise<User> => {
  try {
    if (!auth.currentUser) throw new Error('Utilisateur non connecté');
    if (data.displayName !== undefined) {
      await firebaseUpdateProfile(auth.currentUser, { displayName: data.displayName });
      // Mirror to Firestore users doc
      await setDoc(doc(db, 'users', auth.currentUser.uid), {
        displayName: data.displayName,
        email: auth.currentUser.email,
        updatedAt: serverTimestamp()
      }, { merge: true });
    }
    toast.success('Profil mis à jour');
    return auth.currentUser;
  } catch (error) {
    return handleAuthError(error);
  }
};

export const changePassword = async (newPassword: string): Promise<void> => {
  try {
    if (!auth.currentUser) throw new Error('Utilisateur non connecté');
    await firebaseUpdatePassword(auth.currentUser, newPassword);
    toast.success('Mot de passe mis à jour');
  } catch (error) {
    // Provide clearer guidance on recent login requirement
    if ((error as any)?.code === 'auth/requires-recent-login') {
      toast.error('Veuillez vous reconnecter avant de changer votre mot de passe (sécurité).');
    }
    return handleAuthError(error);
  }
};